// Which of a product's images leads, as live's (`products-list/utils.ts`, read for behaviour):
// the card's cover and the preview's picture are the first product shot, else the first image;
// the preview's "Other images" are the rest.
import type { Product, ProductImage } from "../../api/generated/model";

/** Live's `getProductPreviewImage`: the first product shot, else the first image. */
export function previewImageOf(product: Product): ProductImage | undefined {
  return product.images.find((image) => image.tag === "product_shot") ?? product.images[0];
}

/** Live's `getOtherProductImages`: every image but the leading one. */
export function otherImagesOf(product: Product): ProductImage[] {
  const lead = previewImageOf(product);
  return product.images.filter((image) => image !== lead);
}
